<template>
  <div class="px-4 py-3 flex-1">
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    activity: Object
  },

  computed: {
    text() {
      let type = this.activity.type;
      let subject = this.activity.subject || this.activity.snapshot || {};
      let name = subject.name || "";
      let description = subject.description || "";

      if (type === "contact_created") return "Contact toegevoegd";
      if (type === "reminder_done") return "Taak afgerond";
      if (type === "person_linked") {
        let firstname = subject.firstname || "";
        let lastname = subject.lastname || "";
        return `Contactpersoon "${firstname} ${lastname}" toegevoegd`;
      }
      if (type === "person_unlinked") {
        let firstname = subject.firstname || "";
        let lastname = subject.lastname || "";
        return `Contactpersoon "${firstname} ${lastname}" verwijderd`;
      }
      if (type === "tag_linked") return `Tag "${name}" toegevoegd`;
      if (type === "tag_unlinked") return `Tag "${name}" verwijderd`;
      if (type === "contact_updated") return "Contactgegevens gewijzigd";
      if (type === "status_changed") return `Soort gewijzigd in ${name}`;
      if (type === "reminder_created") return "Notitie met reminder toegevoegd";
      if (type === "deal_created") return `Deal toegevoegd: ${description}`;
      if (type === "deal_won") return `Deal gewonnen: ${description}`;
      if (type === "deal_lost") return `Deal verloren: ${description}`;
      if (type === "deal_pending") return `Pre-Deal toegevoegd: ${description}`;
      if (type === "deal_updated") return `Deal gewijzigd: ${description}`;
      if (type === "manager_changed") return `Beheerder gewijzigd in ${name}`;

      return type;
    }
  }
};
</script>